module.exports = __webpack_public_path__ + "img/38.1a25e519.svg";